// ✅ Action Types
import * as actionTypes from "../ActionTypes";

// ✅ Fetch Carecells
export const fetchCarecellsRequest = (payload, callback) => ({
  type: actionTypes.FETCH_CARECELLS_REQUEST,
  payload,
  callback,
});

export const fetchCarecellsSuccess = (data) => ({
  type: actionTypes.FETCH_CARECELLS_SUCCESS,
  payload: data,
});

export const fetchCarecellsFailure = (error) => ({
  type: actionTypes.FETCH_CARECELLS_FAILURE,
  payload: error,
});

// ✅ Save Carecell
export const saveCarecellRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CARECELL_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCarecellSuccess = (data) => ({
  type: actionTypes.SAVE_CARECELL_SUCCESS,
  payload: data,
});

export const saveCarecellFailure = (error) => ({
  type: actionTypes.SAVE_CARECELL_FAILURE,
  payload: error,
});

// ✅ Update Carecell
export const updateCarecellRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CARECELL_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});


export const updateCarecellSuccess = (data) => ({
  type: actionTypes.UPDATE_CARECELL_SUCCESS,
  payload: data,
});

export const updateCarecellFailure = (error) => ({
  type: actionTypes.UPDATE_CARECELL_FAILURE,
  payload: error,
});

// ✅ Delete Carecell
export const deleteCarecellRequest = (payload, callback) => ({
  type: actionTypes.DELETE_CARECELL_REQUEST,
  payload,
  callback,
});

export const deleteCarecellSuccess = (data) => ({
  type: actionTypes.DELETE_CARECELL_SUCCESS,
  payload: data,
});

export const deleteCarecellFailure = (error) => ({
  type: actionTypes.DELETE_CARECELL_FAILURE,
  payload: error,
});
